import type { IUserProfile } from '@/hooks/useAppState';
import type { MemberTrainingPlan } from '@/lib/memberTrainingDay';
import type { DietPlanTemplate } from '@/data/diet-plan-templates';

export function emptyTrainingSchedule(profile: IUserProfile, dietTemplate: DietPlanTemplate, id: string, now = Date.now()): MemberTrainingPlan {
  return { id, name: '我的训练排期', courseSystem: profile.trainingPlace === 'home' ? 'home' : 'three-way',
    goal: profile.goal, dietTemplate, weeklyHours: 0, sessionMinutes: profile.sessionMinutes || 45,
    trainingPlace: profile.trainingPlace, trainingMonths: profile.trainingMonths, trainingFrequency: profile.trainingFrequency,
    startDate: now, createdAt: now, scheduleMode: 'calendar',
    weekDays: Array.from({ length: 7 }, (_, i) => ({ dayOfWeek: i + 1, type: 'rest', label: '休息日', subtitle: '完全休息', durationMin: 0 })) };
}
